<template lang="pug">
div.monitoring-detail.l-flex-column
    //- TABS
    Tabs.info-tabs(:dataTabs="dataTabs", parent="jobs")
        //- FILE
        template(slot="content", v-if="activeTab === 'file'")
            section.detail-section
                div.sub-header
                    div.sub-header-title File informations
            div.info-content.scrollbar.is-scrollable
                div.info-block
                    div.label Job
                    div.value {{ selectedJob.id }}
                div.info-block
                    div.label Filename
                    div.value(:title="selectedJob.filename") {{ selectedJob.filename }}
                div.info-block
                    div.label Status
                    div.value {{ selectedJob.status }}
                div.info-block
                    div.label Type
                    div.value {{ selectedJob.displayType }}
                div.info-block
                    div.label Retrieved
                    div.value {{ selectedJob.created_at }}
                div.info-block
                    div.label Processed
                    div.value {{ selectedJob.updated_at }}
                div.info-block
                    div.label Email
                    div.value(:title="selectedJob.finish_alert_emails") {{ selectedJob.finish_alert_emails }}
                div.info-block
                    div.label Connection
                    div.value {{ selectedJobConnection.label }}

        //- CONFIGURATION
        template(slot="content", v-if="activeTab === 'configuration'")
            section.detail-section
                div.sub-header
                    div.sub-header-title Configuration informations
            div.info-content.scrollbar.is-scrollable
                div.info-block
                    div.label Configuration name
                    div.value {{ selectedJobConfiguration.label }}
                div.info-block(v-if="selectedJob.displayType !== 'CRM'")
                    div.label Encrypted ids
                    div.value {{ selectedJobConfiguration.is_weboid_crypted }}
                div.info-block
                    div.label File delimitor
                    div.value {{ selectedJobConfiguration.delimitor }}
                div.info-block
                    div.label File compressed
                    div.value {{ selectedJobConfiguration.is_file_compressed }}
                div.info-block(v-if="selectedJob.displayType !== 'Proxy'")
                    div.label Id CRM Pattern
                    div.value {{ selectedJobConfiguration.idcrm_pattern }}
                div.info-block(v-if="selectedJob.displayType !== 'Proxy'")
                    div.label Out CRM Pattern
                    div.value {{ selectedJobConfiguration.out_idcrm_pattern }}
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapGetters } from 'vuex'

import { JOBS_DATATABS } from '@/utils/constants'

import { find, isNil } from 'lodash'

//components
import Panel from '@/components/common/Panel'
import Tabs from '@/components/common/Tabs'

export default {
    name: 'JobsDetails',

    components: { Panel, Tabs },

    props: { jobList: { type: Array, required: true } },

    data() {
        return { dataTabs: JOBS_DATATABS }
    },

    computed: {
        // Call to state
        ...mapState('ui/dataEntry', {
            activeTab: state => state.activeTab,
            selectedJobId: state => state.selectedRowId
        }),
        ...mapGetters('data/dataEntry', ['getConfigurationByJobParentJsonKeyName', 'getConnectionByJobParentJsonKeyName']),

        selectedJob() {
            return find(this.jobList, job => job.id === this.selectedJobId)
        },
        selectedJobConfiguration() {
            return isNil(this.selectedJob) ? null : this.getConfigurationByJobParentJsonKeyName({ parentJsonKeyName: this.selectedJob.parentJsonKeyName })
        },
        selectedJobConnection() {
            return isNil(this.selectedJobConfiguration)
                ? null
                : this.getConnectionByJobParentJsonKeyName({ parentJsonKeyName: this.selectedJobConfiguration.parentJsonKeyName })
        }
    }
}
</script>
